import { Component, Vue } from 'vue-property-decorator'
import { queryClassList, getMentorList, createMentorRelation, classOverAction, editCourseCode } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'class-list-page', components: { HighFilter } })
export default class ClassListPage extends Vue {
  private tableData = []
  private totalPage = 1;
  private currentPage = 1;
  private mentorSelectDialogShow = false
  private mentorChoose = ''
  private classChoose = ''
  private mentorList = []
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading: any =false
  private time: any = null
  created () {
    this.initPageData()
  }

  get inclass () {
    return this.getinclass()
  }

  getinclass () {
    return this.tableData.filter((item: any) => { return item.status === 2 })
  }

  private async initPageData () {
    const list: any = [{ path: '/class/relation/create/mentor', pathName: 'createMentorRelation' }, { path: '/class/edit/courseCode', pathName: 'editCourseCode' }, { pathName: 'classOverAction', path: '/workOrder/submitter/create/classEnd' }]
    this.tableloading = true
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    param.pathList = list
    const result: any = await queryClassList(param)
    this.totalPage = result.allPage
    this.currentPage = result.currentPage
    this.tableData = result.classList
    this.filterData = result.search
    this.tableloading = false
  }

  /**
  * [description] 分页切换回调函数
  */
  private async onPageChange () {
    this.initPageData()
  }

  statusFilter (status: any) {
    const statusStr = ['', '未上课', '上课中', '异常中', '即将结课']
    return statusStr[status]
  }

  async classOverClick (data: any) {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      await classOverAction({ classId: data.classId })
      this.$message({ type: 'success', message: '申请成功' })
      this.initPageData()
    }, 500)
  }

  private rowClicked (row: any) {
    this.$router.push({ path: '/student/class_detail', query: { id: row.classId, detailType: '1' } })
  }

  private async mentorClicked (row: any) {
    this.classChoose = row.classId
    const result: any = await getMentorList({})
    this.mentorList = result
    this.mentorSelectDialogShow = true
  }

  private async onSetClick (type: any) {
    await createMentorRelation({ classId: [this.classChoose], mentorId: this.mentorChoose })
    this.$message({ type: 'success', message: '分配Mentor成功' })
    this.initPageData()
    this.mentorSelectDialogShow = false
    this.mentorChoose = ''
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private async changeCourseCode (item: any) {
    await editCourseCode({ classId: item.classId, courseCode: item.courseCode })
    this.$message({ message: '修改Course Code成功', type: 'success' })
    await this.initPageData()
  }
}
